import { Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

const HelperUseFormula = ({ setHelperUseFormula }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Box
        sx={{
          display: "flex",
          "& p": {
            fontSize: "16px",
            fontWeight: "bold",
          },
          alignItems: "center",
        }}
      >
        <ArrowBackIcon
          onClick={() => {
            setHelperUseFormula(false);
          }}
          sx={{
            padding: "10px",
            borderRadius: "50%",
            marginRight: "10px",
            "&:hover": {
              background: "rgba(0,0,0,.0392156863)",
            },
          }}
        />
        <p>{t("HELP_USE_FORMULA.TUTORIAL")}</p>
      </Box>
      <Box
        sx={{
          "& p": { fontSize: "13px", lineHeight: "1.4" },
          "& p span": { fontSize: "13px" },
          "& p b": { fontSize: "13px" },
        }}
      >
        <p>{t("HELP_USE_FORMULA.TEXT_1")}:</p>
        <p>
          <b>{t("HELP_USE_FORMULA.STEP_1")}: </b>
          {t("HELP_USE_FORMULA.TEXT_STEP_1")}{" "}
          <b>
            {t("HELP_USE_FORMULA.NUMBER")}, {t("HELP_USE_FORMULA.FORMULA")}
          </b>
        </p>
        <p>
          <b>{t("HELP_USE_FORMULA.STEP_2")}: </b>
          {t("HELP_USE_FORMULA.TEXT_STEP_2_1")}
        </p>
        <p>{t("HELP_USE_FORMULA.TEXT_STEP_2_2")}</p>
        <p>{t("HELP_USE_FORMULA.TEXT_STEP_2_3")}</p>
        <p>
          {t("HELP_USE_FORMULA.TEXT_STEP_2_4")}: "
          <b>{t("HELP_USE_FORMULA.TEXT_STEP_2_4_NAME_EX")}</b>"
        </p>
        <p>
          <span style={{ fontWeight: "bold", fontSize: "17px" }}>fx=</span>
          <span
            style={{ color: "#2550E6", fontSize: "17px", fontWeight: "bold" }}
          >
            #{t("HELP_USE_FORMULA.TEXT_STEP_2_EXAMPLE")}_1 - #
            {t("HELP_USE_FORMULA.TEXT_STEP_2_EXAMPLE")}_2
          </span>
        </p>
        <p>
          <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
            {t("HELP_USE_FORMULA.TODO")}
          </span>
        </p>
        <p>
          {t("HELP_USE_FORMULA.STEP_1")}: {t("HELP_USE_FORMULA.TODO_1_TEXT")}{" "}
          {t("HELP_USE_FORMULA.TEXT_STEP_2_EXAMPLE")}_1
        </p>
        <p>
          {t("HELP_USE_FORMULA.STEP_2")}: {t("HELP_USE_FORMULA.TODO_2_TEXT")}
        </p>
        <p>
          {t("HELP_USE_FORMULA.STEP_3")}: {t("HELP_USE_FORMULA.TODO_1_TEXT")}{" "}
          {t("HELP_USE_FORMULA.TEXT_STEP_2_EXAMPLE")}_2
        </p>
        <p>
          {t("HELP_USE_FORMULA.STEP_4")}: {t("HELP_USE_FORMULA.TODO_4_TEXT_1")}{" "}
          <b>{t("HELP_USE_FORMULA.DONE")}</b>{" "}
          {t("HELP_USE_FORMULA.TODO_4_TEXT_2")}
        </p>
      </Box>
    </Box>
  );
};

export default HelperUseFormula;
